import React from 'react'
import routes from './routes'
import { createClient } from 'boiler-room-runner'
import ReactDOM from 'react-dom'
import { configureClientStore } from './store'
import { updateEnvironment } from './lib/environment'
import { parseJSON } from './lib/json'
import createLocals from './lib/createLocals'
import a11y from 'react-a11y'
import 'minimal.css'
import './assets/global.css'

if (process.env.NODE_ENV !== 'production') {
  a11y(React, { ReactDOM })
}

if (typeof Promise === 'undefined') {
  require('es6-promise').polyfill()
}

const basepath = process.env.BASE_PATH
const initialState = parseJSON(document.getElementById('initial-state').innerHTML)
const store = configureClientStore(initialState)
const App = createClient({ basepath, routes, store, createLocals })

if (initialState.site) {
  updateEnvironment(initialState.site.data.environment)
}

ReactDOM.render(<App />, document.getElementById('mount'))



// WEBPACK FOOTER //
// ./client.js